import { CourseOutlineTaskTypeEnum } from './course-outline-task-type-enum'

export interface CourseOutlineTaskInterface {
  /**
   * 目录任务-标题
   */
  name?: string
  /**
   * 目录任务-类型
   */
  type?: CourseOutlineTaskTypeEnum
  /**
   * 目录任务-是否允许下载附件
   */
  allowAttachmentDown?: boolean
  /**
   * 目录任务-附件
   */
  attachments?: object[]
  /**
   * 目录任务-关联的试卷
   */
  paperId?: number
  /**
   * 排序字段，返回数据已经排好序了
   */
  weight?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class CourseOutlineTask implements CourseOutlineTaskInterface {
  /**
   * 目录任务-标题
   */
  name?: string
  /**
   * 目录任务-类型
   */
  type?: CourseOutlineTaskTypeEnum
  /**
   * 目录任务-是否允许下载附件
   */
  allowAttachmentDown?: boolean
  /**
   * 目录任务-附件
   */
  attachments?: object[]
  /**
   * 目录任务-关联的试卷
   */
  paperId?: number
  /**
   * 排序字段，返回数据已经排好序了
   */
  weight?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: CourseOutlineTaskInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      type: _type,
      allowAttachmentDown: _allowAttachmentDown,
      attachments: _attachments,
      paperId: _paperId,
      weight: _weight,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.type = _type
    this.allowAttachmentDown = _allowAttachmentDown
    this.attachments = _attachments
    this.paperId = _paperId
    this.weight = _weight
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
